/**
 * The branch the agency is looking at: one of its branches, or all of them.
 *
 * Client state only, in memory. Set from the sidebar's agency block, or from a screen's own
 * segment (the design's "Mening / Barcha filiallar"). Screens that filter by branch read
 * `branchId`; `null` means "all branches", which is also what a tenant-wide role starts with.
 */
import { create } from "zustand";

interface ScopeState {
  /** `null` is "Barcha filiallar". */
  branchId: number | null;
  setBranchId: (next: number | null) => void;
}

export const useScopeStore = create<ScopeState>((set) => ({
  branchId: null,
  setBranchId: (next: number | null): void => {
    set({ branchId: next });
  },
}));
